export type AppEnv = "local" | "dev" | "qa" | "prod" | "all";

export const getAppEnv = () => {
  return (import.meta.env.VITE_APP_APP_ENV ?? "local") as AppEnv;
};
